import React from 'react'

/** Wspólne elementy sekcji konta — jeden układ, jedno miejsce na zmiany. */

export const SectionTitle = ({ children, hint }) => (
  <div className="mb-5">
    <h2 className="text-lg font-bold text-gray-900">{children}</h2>
    {hint && <p className="mt-1 text-sm text-gray-500 leading-6">{hint}</p>}
  </div>
)

export const inputClass =
  'w-full px-3.5 py-2.5 rounded-lg border border-gray-200 bg-white text-sm ' +
  'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ' +
  'disabled:bg-gray-50 disabled:text-gray-400'

export const Field = ({ label, hint, children }) => (
  <label className="block">
    <span className="block text-sm font-medium text-gray-700 mb-1.5">{label}</span>
    {children}
    {hint && <span className="block mt-1 text-xs text-gray-400">{hint}</span>}
  </label>
)

export const Button = ({ children, busy, variant = 'primary', ...props }) => {
  const style = {
    primary: 'bg-blue-600 text-white hover:bg-blue-500 active:bg-blue-700',
    ghost: 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50',
    danger: 'bg-red-600 text-white hover:bg-red-500 active:bg-red-700',
  }[variant]
  return (
    <button
      type={props.type || 'button'}
      disabled={busy || props.disabled}
      {...props}
      className={`px-4 py-2.5 rounded-lg text-sm font-semibold transition-colors shadow-sm
                  disabled:bg-gray-300 disabled:text-white disabled:cursor-not-allowed ${style}`}
    >
      {busy ? 'Chwileczkę…' : children}
    </button>
  )
}

export const ErrorText = ({ children }) =>
  children ? <p role="alert" className="text-sm text-red-600 leading-6">{children}</p> : null

/**
 * Wybór w formie kafelków — czytelniejszy niż lista checkboxów.
 *
 * `single` przełącza na kółko radia. To nie jest kosmetyka: kwadrat obiecuje,
 * że wolno zaznaczyć kilka pozycji, więc przy wyborze wykluczającym się
 * („mam instalację PV" / „nie mam") kliknięcie drugiej opcji wyglądałoby jak
 * błąd, a nie jak zmiana odpowiedzi.
 */
export const CheckTile = ({ checked, onChange, label, description, single }) => (
  <label
    className={`flex items-start gap-2.5 p-3 rounded-xl border cursor-pointer transition-colors ${
      checked ? 'border-blue-300 bg-blue-50/50' : 'border-gray-200 hover:border-blue-200 hover:bg-gray-50'
    }`}
  >
    <input
      type={single ? 'radio' : 'checkbox'}
      checked={checked}
      onChange={onChange}
      className={`mt-0.5 w-4 h-4 border-gray-300 text-blue-600 focus:ring-blue-500 ${
        single ? '' : 'rounded'
      }`}
    />
    <span className="min-w-0">
      <span className="block text-sm font-medium text-gray-800 leading-snug">{label}</span>
      {description && <span className="block text-xs text-gray-500 mt-0.5">{description}</span>}
    </span>
  </label>
)
